import { WorkflowModelsNS } from 'src/app/misc/workflow/models/add-update-workflow.models';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'workflowActiveActions', pure: false })
export class WorkflowActiveActionsPipe implements PipeTransform {

    transform(actions: Array<any>, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, objectId: number = null): any {
        if (actions && actions.length) {

            let convertInvoiceInstant = (addedCondition?.instantActions?.workflowActionConvertToInvoices?.filter(a=> a.statusId==1 && a?.conversionType!=1 && (objectId ? objectId == a.objectId : true))?.length>0);
            let convertInvoiceTime = ((addedCondition.timeDependentActions?.filter(action=> action.workflowActionConvertToInvoices?.filter(a=> a.statusId==1 && a?.conversionType!=1 && (objectId ? objectId == a.objectId : true))?.length>0))?.length>0);

            if(convertInvoiceInstant || convertInvoiceTime){
                actions = actions.filter(a=> !['convertToInvoice','convertToSalesOrder', 'itemReceipt'].includes(a.code))
            }

            let convertSOInstant = (addedCondition?.instantActions?.workflowActionConvertToInvoices?.filter(a=> a.statusId==1 && a?.conversionType==1 && (objectId ? objectId == a.objectId : true))?.length>0);
            let convertSOTime = ((addedCondition.timeDependentActions?.filter(action=> action.workflowActionConvertToInvoices?.filter(a=> a.statusId==1 && a?.conversionType==1 && (objectId ? objectId == a.objectId : true))?.length>0))?.length>0);

            if(convertSOInstant || convertSOTime){
                actions = actions.filter(a=> !['convertToInvoice','convertToSalesOrder'].includes(a.code))
            }

            let approvalsInstant = (addedCondition?.instantActions?.workflowActionApprovals?.filter(a=> a.statusId==1 && (objectId ? objectId == a.objectId : true))?.length>0);
            let capprovalsTime = ((addedCondition.timeDependentActions?.filter(action=> action.workflowActionApprovals?.filter(a=> a.statusId==1 && (objectId ? objectId == a.objectId : true))?.length>0))?.length>0);

            if(approvalsInstant || capprovalsTime){
                actions = actions.filter(a=> a.id!=WorkflowModelsNS.WorkflowActionTypeEnum.Approval)
            }

            let deleteRecordInstant = (addedCondition?.instantActions?.workflowActionDeleteRecords?.filter(a=> a.statusId==1)?.length>0);
            let deleteRecordTime = ((addedCondition.timeDependentActions?.filter(action=> action.workflowActionDeleteRecords?.filter(a=> a.statusId==1)?.length>0))?.length>0);

            if(deleteRecordInstant || deleteRecordTime){
                actions = actions.filter(a=> a.id!=WorkflowModelsNS.WorkflowActionTypeEnum.DeleteRecord)
            }

            return actions;
        } else {
            return actions;
        }
    }

}
